export const topCategory = [
  { key: 'yogaCategories', value: 'Yoga' },
  { key: 'fitnessCategories', value: 'Fitness' },
  { key: 'mindfulnessCategories', value: 'Mindfulness' },
  { key: 'wellnessCategories', value: 'Wellness' },
  { key: 'skillsCategories', value: 'Skills' }
]
